var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalcustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4375 32.8125C35.4375 29.1881 38.3756 26.25 42 26.25C45.6244 26.25 48.5625 29.1881 48.5625 32.8125C48.5625 36.4369 45.6244 39.375 42 39.375C38.3756 39.375 35.4375 36.4369 35.4375 32.8125Z",
    fill: "#182774"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5625 38.0625C48.5625 35.163 50.913 32.8125 53.8125 32.8125C56.712 32.8125 59.0625 35.163 59.0625 38.0625C59.0625 40.962 56.712 43.3125 53.8125 43.3125C50.913 43.3125 48.5625 40.962 48.5625 38.0625Z",
    fill: "#182774"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9375 38.0625C24.9375 35.163 27.288 32.8125 30.1875 32.8125C33.087 32.8125 35.4375 35.163 35.4375 38.0625C35.4375 40.962 33.087 43.3125 30.1875 43.3125C27.288 43.3125 24.9375 40.962 24.9375 38.0625Z",
    fill: "#182774"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0423 47.4557C34.1387 44.1777 37.8146 42 42 42C46.1859 42 49.8622 44.1783 51.9585 47.4569C53.4078 49.7235 54.0348 52.4566 53.7407 55.1214C53.6947 55.5378 53.4527 55.9073 53.0893 56.1158C49.8215 57.9908 46.0339 59.0625 42 59.0625C37.9661 59.0625 34.1785 57.9908 30.9107 56.1158C30.5473 55.9073 30.3053 55.5378 30.2593 55.1214C29.9651 52.4561 30.5925 49.7225 32.0423 47.4557Z",
    fill: "#182774"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.894 45.9439C29.8729 45.9763 29.852 46.0088 29.8312 46.0413C28.1416 48.6831 27.3684 51.8292 27.6057 54.9308C26.5417 54.7691 25.5092 54.5092 24.5182 54.1602L24.3171 54.0893C23.9501 53.9601 23.6936 53.6268 23.6628 53.2389L23.6459 53.0263C23.632 52.8524 23.625 52.6769 23.625 52.5C23.625 48.974 26.4058 46.0975 29.894 45.9439Z",
    fill: "#182774"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3949 54.9307C56.6322 51.8297 55.8593 48.6843 54.1704 46.0428C54.1493 46.0098 54.128 45.9768 54.1066 45.944C57.5945 46.0978 60.375 48.9742 60.375 52.5C60.375 52.6769 60.368 52.8525 60.3541 53.0263L60.3372 53.2389C60.3063 53.6268 60.0499 53.9601 59.6829 54.0893L59.4817 54.1602C58.491 54.5091 57.4587 54.769 56.3949 54.9307Z",
    fill: "#182774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalcustomers);
export default __webpack_public_path__ + "static/media/totalcustomers.e90f585dd559449ed04a01714423f9ce.svg";
export { ForwardRef as ReactComponent };